import { render, staticRenderFns } from "./PermissionCategorySingleSelector.vue?vue&type=template&id=3ac3a6f2&scoped=true&"
import script from "./PermissionCategorySingleSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionCategorySingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3a6f2",
  null
  
)

export default component.exports